export function FormLabelRequired() {
  return <span className="text-red-500">* </span>;
}
